import React, { useState, useEffect, useRef } from 'react';
import { Row, Col, Button, Modal } from 'react-bootstrap';
import { useParams } from 'react-router-dom';
import * as Yup from 'yup';
import { Formik } from 'formik';
import dynamicUrl from '../../../../helper/dynamicUrls';
import { bgvApi, fetchCaseCompDetails } from '../bgv-api/BgvApi';
import Swal from 'sweetalert2';
import withReactContent from 'sweetalert2-react-content';
import { isEmptyObject } from '../../../../util/utils';
import { getUrl } from '../bgv-api/getUrl';
import { bgvAlerts } from '../bgv-api/bgvAlerts';
import OfacBgv from './verifications/OfacBgv';
import { handleDisabling } from '../bgv-api/bgvHelpers';
import { areFilesInvalid } from '../../../../util/utils';
import * as Constants from '../../../../helper/constants';
import useFullPageLoader from '../../../../helper/useFullPageLoader';
import ClearInsufficiency from './ClearInsufficiency';
import { raiseInsufficiency } from '../../../../api/commonApi';
import { useLocation } from 'react-router-dom/cjs/react-router-dom.min';
import FileUpload from '../../../../components/FileUpload/FileUpload';
import { useSelector } from 'react-redux';
import { dbMapping } from '../bgv-api/dbMapping';

const Ofac = ({ className, rest, newUpload, loadStatus, setLoadStatus, handleNextComponent }) => {
  const caseDetailsFromStore = useSelector((state) => state.caseDetailsData);

  const [ofacData, setofacData] = useState({});
  let { case_id, user_client_id } = useParams();
  const [isDisabled, setIsDisabled] = useState(true);
  const [submitButtonActive, setSubmitButtonActive] = useState(true);
  const [editClientButInsert, setEditClientButInsert] = useState(false);
  const [loadAgain, setLoadAgain] = useState(false);
  const [loader, showLoader, hideLoader] = useFullPageLoader();
  const [isInsufficiency, setIsInsufficiency] = useState(false);
  const [isEdit, setIsEdit] = useState(false);
  const [isOpen, setIsOpen] = useState(false);
  const [comment, setComment] = useState('');
  const [error, setError] = useState('');

  const location = useLocation();
  const isAdmin = sessionStorage.getItem(Constants.Common.user_category) === Constants.PortalUserRoles.Admin;
  let formikRef = useRef();
  const caseId = sessionStorage.getItem('case_id');
  const isClientEmployee = sessionStorage.getItem(Constants.Common.user_type) === Constants.PortalUserRoles.ClientUserTypes.Employee;

  const sweetAlertHandler = (alert) => {
    const MySwal = withReactContent(Swal);
    MySwal.fire({
      title: alert.title,
      text: alert.text,
      icon: alert.type
    });
  };

  const _sendofacInfo = async (data) => {
    let { apiUrl, payloadData } = await getUrl(ofacData, data, newUpload, editClientButInsert);

    if (newUpload) {
      case_id = sessionStorage.getItem('case_id');
      if (case_id === null) {
        case_id = '';
      }
    }

    const bgvResponse = await bgvApi(apiUrl, payloadData, 'OFAC', case_id, user_client_id);

    if (bgvResponse.Error) {
      if (newUpload) {
        sweetAlertHandler(bgvAlerts.compInsertError);
        hideLoader();
      } else {
        sweetAlertHandler(bgvAlerts.compUpdateError);
        hideLoader();
      }
    } else {
      setComment('');
      let uploadParams = bgvResponse.data;

      if (Array.isArray(uploadParams)) {
        for (let index = 0; index < uploadParams.length; index++) {
          let keyNameArr = Object.keys(uploadParams[index]);
          let keyName = keyNameArr[0];
          let blobField = document.getElementById(keyName).files[0];
          let tempObj = uploadParams[index];
          await fetch(tempObj[keyName], {
            method: 'PUT',
            body: blobField
          });
        }
      }

      if (newUpload || editClientButInsert) {
        sweetAlertHandler(bgvAlerts.compInsertSuccess);
      } else {
        sweetAlertHandler(bgvAlerts.compUpdateSuccess);
      }
      setLoadAgain(!loadAgain);
      setLoadStatus(!loadStatus);
      hideLoader();
      isClientEmployee && handleNextComponent();
    }
  };

  const _fetchCaseofac = async () => {
    let caseData;
    const componentMap = dbMapping['OFAC'];
    const storeData = caseDetailsFromStore?.[componentMap];

    if (storeData && !isEmptyObject(storeData)) {
      caseData = storeData;
    } else {
      caseData = await fetchCaseCompDetails(dynamicUrl.fetchIndivCaseUrl, case_id, 'OFAC');
    }

    if (caseData === 'Error') {
      alert('Error while fetching components');
    } else {
      if (isEmptyObject(caseData)) {
        setofacData('N.A.');
        if (sessionStorage.getItem('user_category') === Constants.PortalUserRoles.Client || sessionStorage.getItem('user_category') === Constants.PortalUserRoles.OpsSupervisor || sessionStorage.getItem('user_category') === Constants.PortalUserRoles.CstSupervisor) {
          setIsDisabled(false);
          setSubmitButtonActive(true);
          setEditClientButInsert(true);
        }
      } else {
        setofacData(caseData);
        setIsInsufficiency(caseData?.primaryInsufficiency);
        setComment(caseData?.reason);
      }
    }
  };

  const handleInsufficiency = () => {
    setError("");
    setIsOpen(true);
  };

  const handleOKInsufficiencyModal = async () => {
    setIsInsufficiency(true);
    if (comment === "" && !location.pathname.includes('/client-employee-portal')) {
      setError("comment is required to raise insufficiency");
      return;
    }
    const data = {
      remarks: comment,
      case_id: caseId ? caseId : case_id,
      component: "OFAC",
      subComponent: ""
    };
    showLoader();
    const insuffResponse = await raiseInsufficiency({ data });
    if (insuffResponse === 200) {
      if (location.pathname.includes('/client-employee-portal/ce-addbgv') || location.pathname.includes('/client-employee-portal/client-employee-editbgv')) {
        sweetAlertHandler(bgvAlerts.insufficiencyRaisedSuccessfullyEmp);
      } else {
        sweetAlertHandler(bgvAlerts.insufficiencyRaisedSuccessfully);
      }
    } else {
      sweetAlertHandler(bgvAlerts.insufficiencyRaisedError);
    }
    hideLoader();
    setIsOpen(false);
  };

  const handleCancelInsufficiencyModal = () => {
    setIsInsufficiency(false);
    setIsOpen(false);
    setComment('');
  };

  const handleDataChange = () => setLoadAgain(!loadAgain);

  useEffect(() => {
    setIsDisabled(handleDisabling(newUpload));
    setSubmitButtonActive(!handleDisabling(newUpload));
    if (!newUpload) {
      _fetchCaseofac();
    } else {
      setofacData('N.A.');
    }
  }, [loadAgain]);

  useEffect(() => {
    if (formikRef.current) {
      formikRef.current.validateForm();
    }
  }, [isInsufficiency]);

  return isEmptyObject(ofacData) ? null : (
    <React.Fragment>
      <Formik
        initialValues={{
          candidateName: ofacData === 'N.A.' ? '' : ofacData.candidateName,
          aadharNumber: ofacData === 'N.A.' ? '' : ofacData.aadharNumber,
          permanentAddress: ofacData === 'N.A.' ? '' : ofacData.permanentAddress,
          ofacReportFile: ''
        }}
        validationSchema={Yup.object().shape({
          candidateName: Yup.string()
            .when([], {
              is: () => !isInsufficiency,
              then: Yup.string().required("Candidate Name is required"),
              otherwise: Yup.string().notRequired()
            }),
          aadharNumber: Yup.string()
            .when([], {
              is: () => !isInsufficiency,
              then: Yup.string().required("Aadhar Number is required"),
              otherwise: Yup.string().notRequired()
            }),
          permanentAddress: Yup.string()
            .when([], {
              is: () => !isInsufficiency,
              then: Yup.string().required("Permanent Address is required"),
              otherwise: Yup.string().notRequired()
            }),
        })}
        onSubmit={async (values) => {
          showLoader();

          let combinedValues = {
            candidateName: values.candidateName,
            aadharNumber: values.aadharNumber,
            permanentAddress: values.permanentAddress,
            ofacReportFile: values.ofacReportFile,
            primaryInsufficiency: isAdmin ? false : isInsufficiency,
            isEdited: isEdit,
            reason: comment,
            componentStatus: (isInsufficiency && !isAdmin) ? "InSufficient" : "Awaiting"
          };

          if (combinedValues.ofacReportFile === '')
            combinedValues.ofacReportFile = ofacData.ofacReportFile ? ofacData.ofacReportFile : '';

          let filePresent = document.getElementById('ofacReportFile').files[0];
          if (!filePresent && combinedValues.ofacReportFile === '' && !isInsufficiency) {
            sweetAlertHandler(bgvAlerts.noFilesPresent);
            hideLoader();
          } else {
            let allFilesData = [];
            const fileNameArray = ['ofacReportFile'];

            fileNameArray.forEach((fileName) => {
              let selectedFile = document.getElementById(fileName).files[0];
              if (selectedFile) {
                allFilesData.push(selectedFile);
              }
            });

            if (allFilesData.length === 0) {
              setIsEdit(false);
              _sendofacInfo(combinedValues);
            } else {
              if (areFilesInvalid(allFilesData) !== 0) {
                sweetAlertHandler(bgvAlerts.invalidFilesPresent);
                hideLoader();
              } else {
                setIsEdit(false);
                _sendofacInfo(combinedValues);
              }
            }
          }
        }}
      >
        {({ errors, handleBlur, handleChange, handleSubmit, touched, values }) => (
          <form noValidate onSubmit={handleSubmit} className={className} {...rest}>
            <Row>
              <Col sm={12}>
                <br />
                <Row>
                  <Col sm={4}>
                    <h5>OFAC</h5>
                    {submitButtonActive && !newUpload && <Button type="button" className="btn btn-warning" style={{ position: "absolute", left: 200, marginTop: -32, zIndex: 10, }} onClick={() => setIsEdit(true)}>Edit</Button>}
                  </Col>
                  <Col sm={4}>
                    <ClearInsufficiency caseId={case_id} component='OFAC' caseComponentData={ofacData} reloadData={handleDataChange} setLoadStatus={setLoadStatus} />
                  </Col>
                  <Col sm={4}>
                    {(submitButtonActive && !isAdmin && ((!newUpload && isEdit) || newUpload)) && <Button type="button" style={{ position: "absolute", right: 0, bottom: 0 }} onClick={handleInsufficiency}>Raise Insufficiency</Button>}
                  </Col>
                </Row>
                <hr />
              </Col>
            </Row>

            <fieldset disabled={isDisabled || (!newUpload && !isEdit)}>
              <Row>
                <Col sm={3}></Col>
                <Col sm={6}>
                  <Row className="my-3">
                    <Col sm={3}>
                      <label>Candidate Name</label>
                    </Col>
                    <Col sm={9}>
                      <input
                        className="form-control"
                        name="candidateName"
                        onBlur={handleBlur}
                        onChange={handleChange}
                        type="text"
                        value={values.candidateName}
                      />
                      {touched.candidateName && errors.candidateName ? (
                        <small className="text-danger form-text">{errors.candidateName}</small>
                      ) : null}
                    </Col>
                  </Row>
                  <Row className="my-3">
                    <Col sm={3}>
                      <label>Aadhar Number</label>
                    </Col>
                    <Col sm={9}>
                      <input
                        className="form-control"
                        name="aadharNumber"
                        onBlur={handleBlur}
                        onChange={handleChange}
                        type="text"
                        value={values.aadharNumber}
                      />
                      {touched.aadharNumber && errors.aadharNumber ? (
                        <small className="text-danger form-text">{errors.aadharNumber}</small>
                      ) : null}
                    </Col>
                  </Row>
                  <Row className="my-3">
                    <Col sm={3}>
                      <label>Permanent Address</label>
                    </Col>
                    <Col sm={9}>
                      <textarea
                        className="form-control"
                        name="permanentAddress"
                        onBlur={handleBlur}
                        onChange={handleChange}
                        rows="3"
                        value={values.permanentAddress}
                      />
                      {touched.permanentAddress && errors.permanentAddress ? (
                        <small className="text-danger form-text">{errors.permanentAddress}</small>
                      ) : null}
                    </Col>
                  </Row>
                  <Row className="my-3">
                    <Col sm={3}>
                      <label>OFAC Report File</label>
                    </Col>
                    <Col sm={9}>
                      <FileUpload
                        name={'ofacReportFile'}
                        id={'ofacReportFile'}
                        value={values?.ofacReportFile ? values?.ofacReportFile : ofacData?.ofacReportFile}
                        pickedFileValue={values?.ofacReportFile}
                        handleBlur={handleBlur}
                        handleChange={handleChange}
                        touched={touched.ofacReportFile}
                        errors={errors.ofacReportFile}
                        disabled={isDisabled || (!newUpload && !isEdit)}
                      />
                      {ofacData !== 'N.A.' && ofacData.ofacReportFile !== '' && ofacData.ofacReportFileURL ? (
                        <small style={{ cursor: 'pointer' }} className="text-primary form-text">
                          <a href={ofacData.ofacReportFileURL} target="_blank" rel="noopener noreferrer">
                            {Constants.Common.ViewExistingFile}
                          </a>
                        </small>
                      ) : (
                        (newUpload || editClientButInsert) && !values.ofacReportFile && <small className="text-warning form-text">No file uploaded yet</small>
                      )}
                      {touched.ofacReportFile && errors.ofacReportFile && (
                        <small className="text-danger form-text">{errors.ofacReportFile}</small>
                      )}
                    </Col>
                  </Row>
                </Col>
                <Col sm={3}></Col>
              </Row>
            </fieldset>
            {submitButtonActive && (isEdit || newUpload) && (
              <>
                <Row className="my-3">
                  <Col sm={4}></Col>
                  <Col sm={4}>
                    <Button className="btn-block" color="success" size="large" type="submit" variant="success">
                      Submit
                    </Button>
                  </Col>
                  <Col sm={4}></Col>
                </Row>
              </>
            )}
          </form>
        )}
      </Formik>
      {loader}
      {!newUpload && !isInsufficiency &&
        (sessionStorage.getItem('user_category') === 'Operation Supervisor' ||
          sessionStorage.getItem('user_category') === 'Operation Team' ||
          sessionStorage.getItem('user_category') === 'CST Supervisor' ||
          sessionStorage.getItem('user_category') === 'CST') ? (
        <OfacBgv ofacData={ofacData} reloadData={handleDataChange} loadStatus={loadStatus} setLoadStatus={setLoadStatus} />
      ) : null}
      <Modal centered size="sm" show={isOpen}>
        <Modal.Body>
          <p>Add Comment</p>
          <Col sm={12}>
            <textarea
              className="form-control"
              rows="4"
              placeholder="Enter your comment"
              value={comment}
              onChange={(e) => setComment(e.target.value)}
            />
            {error && <p style={{ color: 'red', fontSize: '12px' }}>{error}</p>}
          </Col>
        </Modal.Body>
        <Modal.Footer>
          <Button color="danger" size="md" variant="danger" onClick={handleCancelInsufficiencyModal}>
            Cancel
          </Button>
          <Button color="success" size="md" variant="success" onClick={handleOKInsufficiencyModal}>
            Ok
          </Button>
        </Modal.Footer>
      </Modal>
    </React.Fragment>
  );
};

export default Ofac;